<div class="wrapper">
    <div class="box w-full">
        <p *ngIf="!message" class="px-8 py-4 text-nowrap flex items-center">...{{ 'common.loading' | translate }}...</p>
        <p *ngIf="message" class="px-8 py-4 text-nowrap flex items-center">{{ message }}</p>
        <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
</div>